// src/Components/pages/SettingsPage.jsx

import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { LucideSettings } from "lucide-react";
import { useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import BackgroundFooter from "../BackgroundFooter";
import NavigationBar from "../Nav";
import Menubar from "../Menubar";
import ManageUsersContent from "./ManageUsersContent";
import AccessLogs from "./AccessLogs";
import "../../ComponentsCss/Settings.css";

const SettingsPage = ({ userData }) => {
  const location = useLocation();
  const { profile,user } = useAuth();
const role = profile?.cognitogroups || user?.["cognito:groups"] || [];

  // Sidebar state
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(() => {
    return JSON.parse(localStorage.getItem("isSidebarCollapsed")) || false;
  });

  // Active tab from Nav.jsx state, fallback to manage-users
  const [activeTab, setActiveTab] = useState(
    location.state?.activeTab || "manage-users"
  );

  const handleSidebarToggle = () => {
    setIsSidebarCollapsed((prev) => !prev);
  };

  const tabs = [
    { key: "manage-users", label: "Manage Users", show: true },
    { key: "access-logs", label: "Access Logs", show: role.includes("Admin") },
  ];

  return (
    <Row className="g-0">
      <Col
        xs={12}
        className={`bg-transparent sidebar-container ${
          isSidebarCollapsed ? "collapsed" : "hello"
        }`}
        style={{
          width: isSidebarCollapsed ? "90px" : "317px",
          transition: "width 0.3s ease",
        }}
      >
        <Menubar
          isCollapsed={isSidebarCollapsed}
          onToggle={handleSidebarToggle}
        />
      </Col>

      <Col
        className="pt-0 px-0 ps-0 section-container"
        style={{
          width: `calc(100% - ${isSidebarCollapsed ? "90px" : "317px"})`,
          transition: "width 0.3s ease",
        }}
      >
        <NavigationBar
          userData={userData}
          isSidebarCollapsed={isSidebarCollapsed}
        />

        <div className="settings-wrapper overflow-auto">
          <div className="settings-header">
            <h3>
              <LucideSettings className="me-2" size={25} />
              Settings
            </h3>
            <p>Manage your application settings and preferences</p>
          </div>

          <div
            style={{
              display: "flex",
              gap: 4,
              borderBottom: "1px solid #E2E6EC",
              padding: "0 28px",
              marginTop: 8,
            }}
          >
            {tabs
              .filter((t) => t.show)
              .map((tab) => (
                <button
                  key={tab.key}
                  onClick={() => setActiveTab(tab.key)}
                  style={{
                    padding: "10px 18px",
                    border: "none",
                    background: "none",
                    fontSize: 13,
                    fontWeight: activeTab === tab.key ? 700 : 500,
                    color: activeTab === tab.key ? "#01696f" : "#5A6577",
                    borderBottom:
                      activeTab === tab.key
                        ? "2px solid #01696f"
                        : "2px solid transparent",
                    cursor: "pointer",
                    transition: "all 0.15s",
                    fontFamily: "Inter, -apple-system, sans-serif",
                  }}
                >
                  {tab.label}
                </button>
              ))}
          </div>

          <div style={{ padding: "24px 0" }}>
            {activeTab === "manage-users" && (
              <Row className="mb-3">
                <Col>
                  <ManageUsersContent />
                </Col>
              </Row>
            )}

            {activeTab === "access-logs" && role.includes("Admin") && (
              <AccessLogs />
            )}
          </div>

          {activeTab === "manage-users" && (
            <>
              <div className="settings-section disabled">
                <div className="settings-section-left">
                  <div className="settings-icon-circle disabled-icon">
                    <i className="bi bi-gear" />
                  </div>
                  <div>
                    <h5 className="settings-title disabled-text">
                      More Settings Coming Soon
                    </h5>
                    <p className="settings-description disabled-text">
                      Additional preferences will be available here
                    </p>
                  </div>
                </div>
              </div>

              <div className="settings-footer-note">
                Your settings are automatically saved and will be applied across
                all modules. Changes take effect immediately.
              </div>
            </>
          )}
        </div>

        <BackgroundFooter isSidebarCollapsed={isSidebarCollapsed} />
      </Col>
    </Row>
  );
};

export default SettingsPage;